import { Checkbox, Col, Divider, Row, Typography } from "antd";
import React from "react";
import { formatDateInMMDDYYYY } from "../../../helpers/date";
import { orderStatusEnums } from "../../../helpers/enums";
import OrderDropDown from "../order-items/OrderDropDown";
import ChatIcon from "./../../../graphics/svgs/chatIcon.svg";
import PrintIcon from "./../../../graphics/svgs/printIcon.svg";
import "./dashboardcard.css";
const OrderHistoryCard: React.FC<IUserOrderHistoryMobileCard> = ({ order }) => {
  const { demoGraphics, painProfile, createdAt, processingDetails } = order;
  const handleOpenPdf = (pdfUrl: string) => {
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.target = "_blank"; // Opens in a new tab
    link.rel = "noopener noreferrer";
    link.click();
  };
  return (
    <>
      <div className="dashboard-item-card">
        <Row className="dashboard-card-single-item-container">
          <Col className="checkbox-dashboard-item mb-10" span={24}>
            <Checkbox />
            <img
              src={PrintIcon}
              onClick={(e) => {
                if (
                  order.processingDetails.orderStatus ===
                    orderStatusEnums.ASSIGNED_RX &&
                  order.processingDetails.shippingLabel !== null
                ) {
                  handleOpenPdf(order.processingDetails.shippingLabel);
                }
              }}
              style={{ width: "25px", cursor: "pointer" }}
            />
            <img src={ChatIcon} style={{ width: "25px", cursor: "pointer" }} />
            {/* <img
              src={ThreeDotsHrz}
              style={{ width: "25px", cursor: "pointer" }}
            /> */}
            <OrderDropDown order={order} />
          </Col>
          <Col span={24}>
            <Typography className="dashboard-card-item-title">
              Pain level & Order date
            </Typography>
            <Typography className="users-table-generic-label">
              {painProfile.painRating}{" "}
              {formatDateInMMDDYYYY(new Date(createdAt), true)}
            </Typography>
            <Divider />
          </Col>

          <Col span={24}>
            <Typography className="dashboard-card-item-title">
              Prescribed formula
            </Typography>

            <Typography className="users-table-generic-label">
              {processingDetails.formulaAssigned !== null
                ? `${processingDetails.formulaAssigned?.activeIngredients},${processingDetails.formulaAssigned?.creamBase}`
                : "---"}
            </Typography>
            <Divider />
          </Col>
          <Col span={24}>
            <Typography className="dashboard-card-item-title">
              Directions
            </Typography>

            <Typography className="users-table-generic-label">
              {processingDetails.instructions || "---"}
            </Typography>
            <Divider />
          </Col>
          <Col span={24}>
            <Typography className="dashboard-card-item-title">
              Order # & Status
            </Typography>

            <Typography className="users-table-generic-label">
              # {processingDetails.orderNumber}
            </Typography>

            <Typography className="order-prescribed-tag">
              {processingDetails.orderStatus}
            </Typography>
            <Divider />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default OrderHistoryCard;
